<template>
  <div>
    <estrelas-avaliacao target-modal="modalElogio" :ementa-id="ementaId" :rating="rating"/>

    <!-- Modal Elogio -->
    <b-modal hide-footer id="modalElogio" body-class="modal-conteudo" header-class="">
      <template slot="modal-title">
        <h5 class="modal-title" id="modalElogioLabel">Obrigado pela avaliação!</h5>
      </template>

      <div class="form-group">
        <label for="exampleFormControlTextarea1">Comente aqui o que achou do conteúdo e aguarde a resposta de um dos nossos mestres.
          :)</label>
        <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="texto"></textarea>
      </div>
      <div class="text-center mb-3">
        <button type="button" @click="enviarRelato()" class="btn btn-secondary">Enviar</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import EstrelasAvaliacao from '@/core/components/EstrelasAvaliacao'
import AvaliacaoTopicoAPI from '@/api/avaliacao-topico-api'
import Swal from 'sweetalert2'

export default {
  name: 'AvaliacaoTopico',
  components: { EstrelasAvaliacao },
  props: {
    ementaId: Number,
    rating: Number
  },
  data () {
    return {
      texto: ''
    }
  },
  methods: {
    enviarRelato: function () {
      const loader = this.$loading.show()
      let url = window.location.href
      AvaliacaoTopicoAPI.enviarRelatoAvaliacao(this.ementaId, this.texto, url).then(() => {
        this.$bvModal.hide('modalElogio')

        loader.hide()

        Swal.fire({
          icon: 'success',
          text: 'Sua mensagem foi enviada com sucesso!'
        }).then(() => {
          this.texto = ''
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
